import ArticlePage from './ArticlePage';
import { comparisonArticles } from '@/mocks/articles';

export default function KakobuyComparisonPage() {
  return <ArticlePage data={comparisonArticles.kakobuy} />;
}